import axios from 'axios';
import { baseUrl } from '@/config';

export default {
  /**
   * E2e 트랜잭션 서비스 리스트를 조회한다.
   * @author Song
   * @return {Object} [response 객체]
   */
  getE2eTransactionSvcList(params) {
    return axios.post(`${baseUrl}/settings/device-registration-e2e/get-transaction-svc-list.do`, params);
  },
  /**
   * E2e 트랜잭션 서비스 상세 정보를 조회한다.
   * @author Song
   * @return {Object} [response 객체]
   */
  getE2eTransactionSvct(objId) {
    return axios.get(`${baseUrl}/settings/device-registration-e2e/get-transaction-svc.do`, { params: { objId } });
  },
  /**
   * E2e 트랜잭션 서비스 리스트를 삭제한다.
   * @author Song
   * @return {Object} [response 객체]
   */
  deleteTransactionSvc(params) {
    return axios.post(`${baseUrl}/settings/device-registration-e2e/delete-transaction-svc.do`, params);
  },
  /**
   * E2e 트랜잭션 서비스 리스트를 수정한다. (이벤트 제외, 관리여부)
   * @author Song
   * @return {Object} [response 객체]
   */
  updateTransactionSvc(params) {
    return axios.post(`${baseUrl}/settings/device-registration-e2e/update-transaction.do`, params);
  },
  /**
   * 관리자원 DB 정보를 조회한다.
   * @author Song
   * @return {Object} [response 객체]
   */
  getDbList() {
    return axios.get(`${baseUrl}/settings/device-registration-e2e/getDbList.do`);
  },
  /**
   * E2E Agent를 조회한다.
   * @author Song
   * @return {Object} [response 객체]
   */
  getAgentList(params) {
    return axios.post(`${baseUrl}/settings/device-registration-e2e/get-agent-list.do`, params);
  },
  /**
   * E2E > 관리자원 DB정보를 추가한다.
   * @author Song
   * @return {Object} [response 객체]
   */
  insertDbList(params) {
    return axios.post(`${baseUrl}/settings/device-registration-e2e/insert-dbList.do`, params);
  },
  /**
   * E2E > 관리자원 DB정보를 수정한다.
   * @author Song
   * @return {Object} [response 객체]
   */
  updateDbList(params) {
    return axios.post(`${baseUrl}/settings/device-registration-e2e/update-dbList.do`, params);
  },
  /**
   * E2E > 관리자원 DB정보를 삭제한다.
   * @author Song
   * @return {Object} [response 객체]
   */
  deleteDbList(params) {
    return axios.post(`${baseUrl}/settings/device-registration-e2e/delete-dbList.do`, params);
  },
  /**
   * E2E > 트랜잭션 서비스를 추가한다.
   * @author Song
   * @return {Object} [response 객체]
   */
  insertTransactionSvc(params) {
    return axios.post(`${baseUrl}/settings/device-registration-e2e/insert-transaction-svc.do`, params);
  },
  /**
   * E2E > 해당 트랜잭션 서비스와 연결된 agent들을 조회한다.
   * @author Song
   * @return {Object} [response 객체]
   */
  getAgentSelectList(params) {
    return axios.post(`${baseUrl}/settings/device-registration-e2e/get-agent-selet-list.do`, params);
  },
  /**
   * E2E > 해당 에이전트 정보를 수정한다.
   * @author Song
   * @return {Object} [response 객체]
   */
  updateAgentInfo(params) {
    return axios.post(`${baseUrl}/settings/device-registration-e2e/update-agent-info.do`, params);
  },
  /**
   * E2E > 해당 에이전트를 삭제한다.
   * @author Song
   * @return {Object} [response 객체]
   */
  deleteAgentList(params) {
    return axios.post(`${baseUrl}/settings/device-registration-e2e/delete-agent-list.do`, params);
  },
  /**
   * E2E > 해당 트랜잭션 서비스 정보를 수정한다.
   * @author Song
   * @return {Object} [response 객체]
   */
  updateTransactionSvcByWizard(params) {
    return axios.post(`${baseUrl}/settings/device-registration-e2e/update-transaction-svc-wizard.do`, params);
  },
  /**
   * E2E > 해당 에이전트 리스트 정책 정보를 수정한다.
   * @author Song
   * @return {Object} [response 객체]
   */
  updateAgentPolicy(params) {
    return axios.post(`${baseUrl}/settings/device-registration-e2e/update-agent-policy.do`, params);
  },
  /**
   * E2E > 3일 이내 등록한 장비 카운트를 조회
   * @author Song
   * @return {Object} [response 객체]
   */
  getRecentRegisteredE2eCount() {
    return axios.get(`${baseUrl}/settings/device-registration-e2e/get-recent-registered-e2e-count.do`);
  },
};



// WEBPACK FOOTER //
// ./src/api/settings/common/device-registration-e2e.js